<template>
  <div class="mku-dropdown-menu">
    <slot></slot>
  </div>
</template>

<script>

export default {
  name: 'MkuDropdownMenu',
};
</script>
